import React from "react";
import "./HighlightsSection.css";
import { FaStarOfLife } from "react-icons/fa6";

const HighlightsSection = ({ title, subtitle, items }) => {
    return (
        <div className="highlights-section">
            <h2 className="highlights-title">{title}</h2>

            <div className="highlights-card-content">
                {subtitle && (
                    <h3 className="highlights-card-title">{subtitle}</h3>
                )}
                <ul className="highlights-list">
                    {items.map((item, idx) => {
                        // Default icon fallback
                        const Icon = item.icon || FaStarOfLife;
                        return (
                            <li key={idx} className="highlights-item">
                                <div className="highlights-icon">
                                    {typeof Icon === "string" ? Icon : <Icon />}
                                </div>
                                <div className='highlights-item-text'>
                                    {item.title && (
                                        <div className="highlights-item-title">{item.title}</div>
                                    )}
                                    {item.text && (
                                        <div className="highlights-item-description">{item.text}</div>
                                    )}
                                </div>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    );
};

export default HighlightsSection;
